var React = require('react');

function Search (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"ICONS_nieuwwwwww"),React.createElement("path",{"d":"M77,71.22,52.54,46.82a29.35,29.35,0,1,0-7.1,6.69L70.05,78.12a4.88,4.88,0,0,0,6.9-6.9Zm-28-42A20.13,20.13,0,1,1,28.79,9.1,20.15,20.15,0,0,1,48.92,29.22Z","fill":"#2a2d58","key":1})]);
}

Search.defaultProps = {"viewBox":"0 0 78.37 79.54"};

module.exports = Search;

Search.default = Search;
